import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as filters from './filters';
import 'amfe-flexible'
import { DropdownMenu, DropdownItem,Icon,Button, Field, Tabbar, TabbarItem, Search, NavBar, Popup, Pagination, Dialog, Toast, Cell, CellGroup, PullRefresh, List, Loading, NumberKeyboard, Stepper, Checkbox, CheckboxGroup } from 'vant'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import animated from 'animate.css'
import 'swiper/dist/css/swiper.css'
import VueSignaturePad from 'vue-signature-pad';
// import vconsole from 'vconsole'
// let Vconsole =  new vconsole

Vue.use(VueSignaturePad);
Vue.use(animated)
Vue.use(VueAwesomeSwiper)
// Vue.prototype.$axios = axios;
Vue.config.productionTip = false
Vue.use(Button).use(Icon).use(Field).use(Tabbar).use(TabbarItem).use(Search).use(NavBar).use(Popup).use(Pagination).use(Dialog).use(Toast).use(PullRefresh).use(List).use(Loading).use(NumberKeyboard).use(Stepper).use(Checkbox).use(CheckboxGroup).use(Cell).use(CellGroup)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

document.documentElement.addEventListener('touchstart', function (event) {
  if (event.touches.length > 1) {
    event.preventDefault();
  }
}, {
  passive: false
});

var lastTouchEnd = 0;
document.documentElement.addEventListener('touchend', function (event) {
  var now = Date.now();
  if (now - lastTouchEnd <= 300) {
    event.preventDefault();
  }
  lastTouchEnd = now;
}, false);

let homeScrollTop = 0;
Vue.prototype.$homeScroll = homeScrollTop;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
